import { Link } from '@mui/material';

import type { Station } from '@/modules/api/backend';

interface RmvStationLinkProps {
  station: Station;
}

export function RmvStationLink({ station }: RmvStationLinkProps) {
  return (
    <Link
      href={`https://www.rmv.de/auskunft/bin/jp/stboard.exe/dn?input=${station.rmvNumber}&boardType=dep&=arr&time=now&maxJourneys=50&dateBegin=&dateEnd=&selectDate=today&productsFilter=1111111111111111&start=yes&dirInput=`}
      sx={{ textDecoration: 'none', px: 2 }}
      target="_blank"
    >
      Zum Abfahrtsplan für {station.name}
    </Link>
  );
}
